import { AuthorizedProjectView36p4bgamz7ogy as AuthorizedProjectView } from '../common/AuthorizedProjectView.mjs';
import { ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance } from '../common/ProjectView.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_project24re8n4hoe63y as get_project,
  get_partyq13c2hdc8rqy as get_party,
  get_state3dimnrbngbj36 as get_state,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectLedgerItemFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import {
  Party_Client_getInstance1cdrz74lwe2vi as Party_Client_getInstance,
  PaymentState_AwaitingConfirmation_getInstance3vwisicrp8je as PaymentState_AwaitingConfirmation_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { andvtrcuje7baox as and } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  _MonetaryValue___get_absoluteValue__impl__hjldkw3vj23mkf30f7c as _MonetaryValue___get_absoluteValue__impl__hjldkw,
  PendingCashOutimavqmg4ecmt as PendingCashOut,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { LateInitSignal30crwrg540xyy as LateInitSignal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientProjectClass;
function ClientProject() {
  if (ClientProjectClass === VOID) {
    class $ extends AuthorizedProjectView() {
      constructor(projectId) {
        super(ProjectLens_Customer_getInstance(), projectId);
      }
      dev() {
        return this.qgj_1;
      }
    }
    initMetadataForClass($, 'ClientProject', VOID, VOID, VOID, [1]);
    ClientProjectClass = $;
  }
  return ClientProjectClass;
}
function *_generator_retrievePaymentInfo__nex0l8($this, $completion) {
  var tmp = await_0(get_session(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().dfh_1.tfs($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.mgl_1.iah(tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_retrievePaymentPendingCash__nq3rdk($this, $completion) {
  var tmp = await_0(get_session(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp$ret$3 = and(and(eq(get_project(it), $this.kgl_1), eq(get_party(it), Party_Client_getInstance())), eq(get_state(it), PaymentState_AwaitingConfirmation_getInstance()));
  var tmp$ret$4 = new (Query())(tmp$ret$3, orderBy, 0, 100);
  var tmp_1 = tmp.sfv_1.tdv_1.cek(tmp$ret$4, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var this_0 = tmp_1;
  var sum = Companion_instance.r91(0n);
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_2 = sum;
    var tmp$ret$5 = element.s7k_1;
    sum = MonetaryValue__plus_impl_c1ylt(tmp_2, tmp$ret$5);
  }
  var tmp$ret$6 = sum;
  var available = _MonetaryValue___get_absoluteValue__impl__hjldkw(tmp$ret$6);
  var tmp_3 = $this.lgl_1.iah(new (PendingCashOut())(available, available), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function *_generator_requestDirectDepositCashOut__u97bgf($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = s.vfw().rfg_1.mfp($this.kgl_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = s.sfv_1.deo($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  $this.lgl_1.uaq();
  var tmp_2 = delay(500n, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = $this.ngl($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function *_generator_requestPhysicalCheckCashOut__x1k8jp($this, request, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = s.vfw().rfg_1.nfp($this.kgl_1, request, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = s.sfv_1.deo($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  $this.lgl_1.uaq();
  var tmp_2 = delay(500n, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = $this.ngl($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
var ClientPaymentInfoClass;
function ClientPaymentInfo() {
  if (ClientPaymentInfoClass === VOID) {
    class $ {
      constructor(projectId) {
        this.kgl_1 = projectId;
        this.lgl_1 = LateInitSignal().taq();
        this.mgl_1 = LateInitSignal().taq();
      }
      fi8() {
        return this.mgl_1;
      }
      yi7($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_retrievePaymentInfo__nex0l8.bind(VOID, this), $completion);
      }
      ngl($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_retrievePaymentPendingCash__nq3rdk.bind(VOID, this), $completion);
      }
      bi8($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_requestDirectDepositCashOut__u97bgf.bind(VOID, this), $completion);
      }
      oi8(request, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_requestPhysicalCheckCashOut__x1k8jp.bind(VOID, this, request), $completion);
      }
    }
    initMetadataForClass($, 'ClientPaymentInfo', VOID, VOID, VOID, [0, 1]);
    ClientPaymentInfoClass = $;
  }
  return ClientPaymentInfoClass;
}
//region block: exports
export {
  ClientPaymentInfo as ClientPaymentInfo323a5wacn9ntp,
  ClientProject as ClientProject3d3kef0q1hn13,
};
//endregion

//# sourceMappingURL=ClientProject.mjs.map
